/**
 * Capacity calculation utilities for V5000 metrics
 * Provides shared helpers for capacity-related calculations
 */

import { parseEncodingScheme } from "../../utils/configUtilities";
import { calculateWriteEfficiency } from "./performanceHelpers";


export const calculateCapacity = (nodeCount, drivesPerNode, driveCapacityTB) => {
    return nodeCount * drivesPerNode * driveCapacityTB;
}

/**
 * Calculate burst capacity for hybrid storage
 * 
 * MORK TODO : Investigate if this is actually used and how this can be improved and made less of a magic number
 * 
 * @param {Object} config - Configuration object
 * @param {Object} ssdPerVpod - value comes from Product database
 * @returns {number} Burst capacity in TB
 */
export const calculateHybridBurstCapacity = (config, ssdPerVpod, encodingScheme) => {
  return (config.hybridVpodSsdCapacity - 1) * 
         ssdPerVpod * 
         config.hybridNodeCount * 
         calculateWriteEfficiency(encodingScheme);
         //MORK TODO :  * config.hybridCompressionRatio to fix?? Need to verify;
};

// /**
//  * Calculate total power consumption for components
//  * @param {number} count - Number of components
//  * @param {Object} productDb - Product database
//  * @param {string} partNumber - Component part number
//  * @returns {number} Total nominal power in watts
//  */
// export const calculateComponentPower = (count, productDb, partNumber) => {
//     const specs = getProductDescription(productDb, partNumber);
//     return count * specs.nominalPower;
// };

// /**
//  * Calculate total weight for components
//  * @param {number} count - Number of components
//  * @param {Object} productDb - Product database
//  * @param {string} partNumber - Component part number
//  * @returns {number} Total weight in lbs
//  */
// export const calculateComponentWeight = (count, productDb, partNumber) => {
//     const specs = getProductDescription(productDb, partNumber);
//     return count * specs.weight;
// };

// /**
//  * Calculate total rack units (RU) for components
//  * @param {number} count - Number of components
//  * @param {number} ruPerUnit - RU per single component
//  * @returns {number} Total RU
//  */
// export const calculateRackUnits = (count, ruPerUnit) => {
//     return count * ruPerUnit;
// };